import { useTheme } from '@src/theme/useTheme';
import './SantaFace.css';

/** The theme's secret gift giver: Santa in winter, a witch at Halloween. */
export function SantaFace() {
  const { seasonPackage } = useTheme();
  return <img className="santa-face" src={seasonPackage.gamePictures.santa} alt="" aria-hidden="true" />;
}
